// pages/AdminLoginPage.jsx
import { useParams, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import axios from 'axios';
import { adminPageLogin } from '../../../services/authService';
import { setLocalStorageIfExists } from '../../..//utils/setLocalStorageIfExists';

const AdminLoginPage = () => {
  const { admin_token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const loginAsUser = async () => {
      try {
        const response = await adminPageLogin({admin_token:admin_token});
        if (response?.data){
          localStorage.setItem('token', response?.data?.token);
          setLocalStorageIfExists('email', response?.data?.email);
          setLocalStorageIfExists('first_name', response?.data?.first_name);
          setLocalStorageIfExists('last_name', response?.data?.last_name);
          setLocalStorageIfExists('block-user', response?.data?.is_blocked);
          localStorage.setItem('need_marketplace_account', response?.data?.need_marketplace_account);
          localStorage.setItem('email_verify', response?.data?.email_verify);
          navigate('/dashboard')
        } else {
          console.error('sssssssss')
        }
      } catch (error) {
        console.error("Login as user error:", error);
      }
    };

    if (admin_token) {
      loginAsUser();
    }
  }, [admin_token, navigate]);

};

export default AdminLoginPage;
